import React from 'react';

import { CrmCustomFieldsBase } from './CrmCustomFieldsBase';

export class CrmAccountsCustomFields extends CrmCustomFieldsBase {
  constructor(props) {
    super(props, {
      groupIdKey: 'settingscrmaccountsfields',
      pageTitleKey: 'crm-accounts-custom-fields',
    });
  }
}